import { multiFranchiseAxios } from '../axios/multiFranchiseAxios';

// Interface for Warehouse Master Response
export interface IWarehouseMaster {
  daysString: string;
  id: number;
  uuid: string;
  code: string;
  name_th: string;
  name_en: string;
  tel: string;
  full_address: string;
  address: string;
  zip_code: string;
  province_id: number;
  province_name: string;
  province_code: string;
  district_id: number;
  district_name: string;
  district_code: string;
  default_delivery_schedule_uuid: string;
  sub_district_id: number | null;
  sub_district_name: string;
  remark: string;
  status: number;
  is_active: number;
  created_at: string;
  updated_at: string | null;
  removed_at: string | null;
  window_times: any[];
}

// API Function to get all warehouse masters
export const APIGetWarehouseMasters = async (): Promise<IWarehouseMaster[]> => {
  try {
    const response = await multiFranchiseAxios.get('/procurement/warehouse-master/all');
    return response.data;
  } catch (error) {
    console.error('Error fetching warehouse masters:', error);
    throw new Error(`Error at APIGetWarehouseMasters: ${error}`);
  }
};
